import {
  PARTICULAR_PLAN_GROUP_CODE,
  ZUP_PLAN_GROUP_CODE,
  FUNDACAO_JOSE_LUIZ_EGIDIO_PLAN_GROUP_CODE,
  HELLNER_PLAN_GROUP_CODE,
  HELLNER_PROGRAMA_GUIAR_PLAN_GROUP_CODE,
  DEXTRA_PLAN_GROUP_CODE,
  RESTOQUE_PLAN_GROUP_CODE,
  DATTOS_PLAN_GROUP_CODE,
  PILLAR_PLAN_GROUP_CODE,
  ALBERT_EINSTEIN_PLAN_GROUP_CODE,
} from './_planGroupCode'

// Para os planos abaixo, o disclaimer para aproveitar os benefícios da consulta na tela inicial do paciente não deve ser exibido.
export const PLANS_TO_NOT_SHOW_PATIENT_HOME_DISCLAIMER = [
  PARTICULAR_PLAN_GROUP_CODE,
  ZUP_PLAN_GROUP_CODE,
  FUNDACAO_JOSE_LUIZ_EGIDIO_PLAN_GROUP_CODE,
  HELLNER_PLAN_GROUP_CODE,
  HELLNER_PROGRAMA_GUIAR_PLAN_GROUP_CODE,
  DEXTRA_PLAN_GROUP_CODE,
  RESTOQUE_PLAN_GROUP_CODE,
  DATTOS_PLAN_GROUP_CODE,
  PILLAR_PLAN_GROUP_CODE,
  ALBERT_EINSTEIN_PLAN_GROUP_CODE,
]